(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["poshaak-flexible-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp-section]').forEach((section) => {
    const form = section.querySelector('[data-pdp-form]');
    const variantId = section.querySelector('[data-pdp-variant-id]');
    const price = section.querySelector('[data-pdp-price]');
    const compare = section.querySelector('[data-pdp-compare]');
    const sku = section.querySelector('[data-pdp-sku]');
    const skuValue = section.querySelector('[data-pdp-sku-value]');
    const shippingSize = section.querySelector('[data-pdp-shipping-size]');
    const shippingStatus = section.querySelector('[data-pdp-shipping-status]');
    const shippingTimeline = section.querySelector('[data-pdp-shipping-timeline]');
    const addButton = section.querySelector('[data-pdp-add]');
    const buyNowButton = section.querySelector('[data-pdp-buy-now]');
    const returnTo = section.querySelector('[data-pdp-return-to]');
    const customToggle = section.querySelector('[data-pdp-custom-size-toggle]');
    const customPanel = section.querySelector('[data-pdp-custom-size-panel]');
    const customBaseSize = section.querySelector('[data-pdp-custom-base-size]');
    const sizeDialog = section.querySelector('[data-pdp-size-dialog]');
    let buyingNow = false;

    const applySelection = (input) => {
      if (variantId) variantId.value = input.dataset.variantId || input.value;
      if (price) price.textContent = input.dataset.price || '';
      if (sku && skuValue) {
        const selectedSku = input.dataset.sku || '';
        skuValue.textContent = selectedSku;
        sku.hidden = !selectedSku;
      }
      if (compare) {
        compare.textContent = input.dataset.compare || '';
        compare.hidden = !input.dataset.compare;
      }
      const isRts = input.dataset.rts === 'true';
      if (shippingSize) shippingSize.textContent = input.dataset.sizeLabel || input.value;
      if (shippingStatus) shippingStatus.textContent = isRts ? section.dataset.pdpRtsLabel : section.dataset.pdpMtoLabel;
      if (shippingTimeline) shippingTimeline.textContent = isRts ? 'Ships in 3–4 Days' : 'Ships in 35–45 Days';
      const available = input.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (buyNowButton) buyNowButton.disabled = !available;
    };

    const setCustomFields = (enabled) => {
      if (customPanel) customPanel.hidden = !enabled;
      section.querySelectorAll('[data-pdp-custom-input]').forEach((field) => {
        field.disabled = !enabled;
        field.required = enabled && field.dataset.pdpCustomRequired === 'true';
      });
      if (enabled && customPanel) customPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    section.querySelectorAll('[data-pdp-media-control]').forEach((control) => {
      control.addEventListener('click', () => {
        const index = control.dataset.pdpMediaControl;
        section.querySelectorAll('[data-pdp-media-panel]').forEach((panel) => { panel.hidden = panel.dataset.pdpMediaPanel !== index; });
        section.querySelectorAll('[data-pdp-media-control]').forEach((item) => {
          const selected = item === control;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    });

    section.querySelectorAll('[data-pdp-option]').forEach((option) => {
      option.addEventListener('change', () => {
        if (!option.checked) return;
        applySelection(option);
        setCustomFields(false);
      });
    });

    customToggle?.addEventListener('change', () => {
      if (!customToggle.checked) return;
      applySelection(customToggle);
      if (customBaseSize) customBaseSize.value = customToggle.dataset.baseSize || '';
      setCustomFields(true);
    });

    section.querySelector('[data-pdp-size-guide]')?.addEventListener('click', () => {
      if (sizeDialog && typeof sizeDialog.showModal === 'function') sizeDialog.showModal();
    });
    section.querySelector('[data-pdp-size-close]')?.addEventListener('click', () => sizeDialog?.close());
    sizeDialog?.addEventListener('click', (event) => { if (event.target === sizeDialog) sizeDialog.close(); });

    form?.addEventListener('submit', () => { if (returnTo && !buyingNow) returnTo.value = ''; });
    buyNowButton?.addEventListener('click', () => {
      if (!form || buyNowButton.disabled) return;
      buyingNow = true;
      if (returnTo) returnTo.value = '/checkout';
      form.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poshaak-home-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pht-section]').forEach((section) => {
    if (section.dataset.phtReady) return;
    section.dataset.phtReady = 'true';
    const track = section.querySelector('[data-pht-track]');
    const previous = section.querySelector('[data-pht-previous]');
    const next = section.querySelector('[data-pht-next]');
    const move = (direction) => {
      const card = track.querySelector('.PHome__LiveTestimonial');
      if (!card) return;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 24), behavior: 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poshaak-redesign-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-poshaak-redesign-header]').forEach((header) => {
    const menu = header.querySelector('.poshaak-redesign-header__mobile-menu');
    const closeButton = header.querySelector('[data-poshaak-menu-close]');
    if (menu && closeButton) closeButton.addEventListener('click', () => menu.removeAttribute('open'));
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu && menu.open) {
        menu.removeAttribute('open');
        const summary = menu.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poshaak-redesign-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp-section]').forEach((section) => {
    const dialog = section.querySelector('[data-pdp-dialog]');
    const sizeDialog = section.querySelector('[data-pdp-size-dialog]');
    const dialogImage = section.querySelector('.poshaak-linesheet-pdp__dialog-image');
    const price = section.querySelector('[data-pdp-price]');
    const compare = section.querySelector('[data-pdp-compare]');
    const sku = section.querySelector('[data-pdp-sku]');
    const skuValue = section.querySelector('[data-pdp-sku-value]');
    const status = section.querySelector('[data-pdp-status]');
    const shippingSize = section.querySelector('[data-pdp-shipping-size]');
    const shippingStatus = section.querySelector('[data-pdp-shipping-status]');
    const shippingTimeline = section.querySelector('[data-pdp-shipping-timeline]');
    const mtoPriceRow = section.querySelector('[data-pdp-mto-price-row]');
    const mtoPrice = section.querySelector('[data-pdp-mto-price]');
    const form = section.querySelector('[data-pdp-form]');
    const variantId = section.querySelector('[data-pdp-variant-id]');
    const returnTo = section.querySelector('[data-pdp-return-to]');
    const addButton = section.querySelector('[data-pdp-add]');
    const buyNowButton = section.querySelector('[data-pdp-buy-now]');
    const customisation = section.querySelector('[data-pdp-customisation]');
    const measurementDialog = section.querySelector('[data-pdp-measurement-dialog]');
    const measurementSave = section.querySelector('[data-pdp-measurement-save]');
    const measurementClose = section.querySelector('[data-pdp-measurement-close]');
    const measurementError = section.querySelector('[data-pdp-measurement-error]');
    const measurementState = section.querySelector('[data-pdp-measurement-state]');
    const customSizeToggle = section.querySelector('[data-pdp-custom-size-toggle]');
    const customSizeInputs = section.querySelectorAll('[data-pdp-custom-input]');
    const measurementFields = section.querySelectorAll('[data-pdp-measurement-field]');
    let customMeasurementsSaved = false;

    // The former Infinite Options app injects a second, hidden measurement form after a Custom selection.
    // Keep it out of the product form so only this PDP's labelled properties reach the cart and order.
    const disableLegacyMeasurementInjection = () => {
      section
        .querySelectorAll('#infiniteoptions-container input, #infiniteoptions-container select, #infiniteoptions-container textarea')
        .forEach((field) => {
          field.disabled = true;
        });
      section.querySelectorAll('#myModal1').forEach((legacyDialog) => {
        legacyDialog.hidden = true;
        legacyDialog.setAttribute('aria-hidden', 'true');
      });
    };
    disableLegacyMeasurementInjection();
    const legacyMeasurementObserver = new MutationObserver(disableLegacyMeasurementInjection);
    legacyMeasurementObserver.observe(section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
    let buyingNow = false;

    const mediaWrap = section.querySelector('[data-pdp-media-wrap]');
    const thumbnailRail = section.querySelector('.poshaak-linesheet-pdp__rail');
    const thumbnails = Array.from(section.querySelectorAll('[data-pdp-thumbnail]'));
    const mediaItems = Array.from(section.querySelectorAll('[data-pdp-media-item]'));

    const activateThumbnail = (mediaIndex, reveal = false) => {
      let activeThumbnail = null;
      thumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.mediaIndex === mediaIndex;
        thumbnail.classList.toggle('is-selected', isActive);
        thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) activeThumbnail = thumbnail;
      });
      if (reveal && activeThumbnail && thumbnailRail && window.innerWidth > 560) {
        const thumbnailTop = activeThumbnail.offsetTop;
        const thumbnailBottom = thumbnailTop + activeThumbnail.offsetHeight;
        const visibleTop = thumbnailRail.scrollTop;
        const visibleBottom = visibleTop + thumbnailRail.clientHeight;
        if (thumbnailTop < visibleTop || thumbnailBottom > visibleBottom) {
          const centeredTop = thumbnailTop - (thumbnailRail.clientHeight - activeThumbnail.offsetHeight) / 2;
          thumbnailRail.scrollTo({ top: Math.max(0, centeredTop), behavior: 'smooth' });
        }
      }
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const mediaIndex = thumbnail.dataset.mediaIndex;
        const target = mediaItems.find((item) => item.dataset.mediaIndex === mediaIndex);
        if (!target) return;
        window.poshaakLoadDeferredImage?.(target);
        activateThumbnail(mediaIndex, true);
        if (window.innerWidth <= 560 && mediaWrap) {
          mediaWrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          return;
        }
        const stickyOffset = window.innerWidth > 860 ? 132 : 20;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - stickyOffset;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
      });
    });

    let galleryScrollFrame = null;
    const syncThumbnailToScroll = () => {
      galleryScrollFrame = null;
      if (!mediaItems.length) return;
      let activeItem = mediaItems[0];
      if (window.innerWidth <= 560 && mediaWrap) {
        let nearestDistance = Number.POSITIVE_INFINITY;
        mediaItems.forEach((item) => {
          const distance = Math.abs(item.offsetLeft - mediaWrap.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            activeItem = item;
          }
        });
      } else {
        const stickyOffset = window.innerWidth > 860 ? 144 : Math.min(100, window.innerHeight * 0.2);
        mediaItems.forEach((item) => {
          if (item.getBoundingClientRect().top <= stickyOffset) activeItem = item;
        });
      }
      activateThumbnail(activeItem.dataset.mediaIndex, true);
    };
    const scheduleGallerySync = () => {
      if (galleryScrollFrame !== null) return;
      galleryScrollFrame = window.requestAnimationFrame(syncThumbnailToScroll);
    };
    window.addEventListener('scroll', scheduleGallerySync, { passive: true });
    window.addEventListener('resize', scheduleGallerySync);
    mediaWrap?.addEventListener('scroll', scheduleGallerySync, { passive: true });
    syncThumbnailToScroll();

    section.querySelectorAll('[data-pdp-zoom-open]').forEach((zoomButton) => {
      zoomButton.addEventListener('click', () => {
        window.poshaakLoadDeferredImage?.(zoomButton.closest('[data-pdp-media-item]'));
        const mainImage = zoomButton
          .closest('[data-pdp-media-item]')
          ?.querySelector('.poshaak-linesheet-pdp__main-image');
        if (!dialog || !dialogImage || !mainImage || typeof dialog.showModal !== 'function') return;
        dialogImage.removeAttribute('srcset');
        dialogImage.removeAttribute('sizes');
        dialogImage.src = zoomButton.dataset.pdpZoomSrc || mainImage.currentSrc || mainImage.src;
        dialogImage.alt = mainImage.alt;
        dialog.showModal();
      });
    });
    section.querySelector('[data-pdp-zoom-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    section.querySelector('[data-pdp-size-guide]')?.addEventListener('click', () => {
      if (sizeDialog && typeof sizeDialog.showModal === 'function') sizeDialog.showModal();
    });
    section.querySelector('[data-pdp-size-close]')?.addEventListener('click', () => sizeDialog?.close());
    sizeDialog?.addEventListener('click', (event) => {
      if (event.target === sizeDialog) sizeDialog.close();
    });

    section.querySelectorAll('[data-pdp-option]').forEach((option) => {
      option.addEventListener('change', () => {
        if (!option.checked) return;
        const customSizeSelected = option.matches('[data-pdp-custom-size-toggle]');
        const isRts = option.dataset.rts === 'true';
        const isAvailable = option.dataset.available === 'true';

        if (variantId) variantId.value = option.dataset.variantId || option.value;
        if (price) price.innerHTML = `<span class="money">${option.dataset.price || ''}</span>`;
        if (sku && skuValue) {
          const selectedSku = option.dataset.sku || '';
          skuValue.textContent = selectedSku;
          sku.hidden = !selectedSku;
        }
        if (compare) {
          compare.innerHTML = `<span class="money">${option.dataset.compare || ''}</span>`;
          compare.hidden = !option.dataset.compare;
        }
        if (status) status.textContent = isRts ? section.dataset.rtsLabel : section.dataset.madeLabel;
        if (shippingSize) shippingSize.textContent = option.dataset.sizeLabel || option.value;
        if (shippingStatus) shippingStatus.textContent = isRts ? section.dataset.rtsLabel : section.dataset.madeLabel;
        if (shippingTimeline) shippingTimeline.textContent = isRts ? 'Ships in 3–4 Days' : 'Ships in 35–45 Days';
        if (mtoPriceRow && mtoPrice) {
          const showMtoPrice = !isRts && option.dataset.mtoPrice;
          mtoPrice.innerHTML = `<span class="money">${option.dataset.mtoPrice || ''}</span>`;
          mtoPriceRow.hidden = !showMtoPrice;
        }
        if (addButton) addButton.disabled = !isAvailable;
        if (buyNowButton) buyNowButton.disabled = !isAvailable;
        customSizeInputs.forEach((input) => {
          input.disabled = !customSizeSelected;
        });
        if (customSizeSelected && measurementDialog && !measurementDialog.open) {
          measurementDialog.showModal();
        }
        if (!customSizeSelected) {
          customMeasurementsSaved = false;
          if (measurementState) measurementState.hidden = true;
        }
      });
    });

    const openMeasurementDialog = () => {
      if (measurementDialog && !measurementDialog.open) measurementDialog.showModal();
    };

    customSizeToggle?.addEventListener('click', () => {
      window.setTimeout(() => {
        if (customSizeToggle.checked) openMeasurementDialog();
      }, 0);
    });

    measurementClose?.addEventListener('click', () => measurementDialog?.close());
    measurementDialog?.addEventListener('click', (event) => {
      if (event.target === measurementDialog) measurementDialog.close();
    });

    measurementSave?.addEventListener('click', () => {
      const hasMeasurement = Array.from(measurementFields).some((field) => field.value.trim() !== '');
      if (!hasMeasurement) {
        if (measurementError) measurementError.hidden = false;
        measurementFields[0]?.focus();
        return;
      }
      customMeasurementsSaved = true;
      if (measurementError) measurementError.hidden = true;
      if (measurementState) {
        measurementState.textContent = 'Measurements saved for this product';
        measurementState.hidden = false;
      }
      measurementDialog?.close();
    });

    form?.addEventListener('submit', (event) => {
      if (customSizeToggle?.checked && !customMeasurementsSaved) {
        event.preventDefault();
        buyingNow = false;
        openMeasurementDialog();
        return;
      }
      if (returnTo && !buyingNow) returnTo.value = '';
    });

    buyNowButton?.addEventListener('click', () => {
      if (!form || buyNowButton.disabled) return;
      buyingNow = true;
      if (returnTo) returnTo.value = '/checkout';
      form.requestSubmit();
    });

    const resizeCustomisationInput = () => {
      if (!customisation) return;
      const characters = Math.max(14, customisation.value.length + 2);
      customisation.style.width = `${Math.min(360, Math.max(128, characters * 7.2))}px`;
    };

    customisation?.addEventListener('input', resizeCustomisationInput);
    resizeCustomisationInput();
  });

  } catch(e) { console.error(e); }
})();
})();
